import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithHandlingUnauthorized } from '@ui/src';

const api = createApi({
  reducerPath: 'accountsApi',
  baseQuery: baseQueryWithHandlingUnauthorized(process.env.API_HOST as string),
  tagTypes: [
    'Accounts',
    'Categories',
    'Groups',
    'Pirmary Accounts',
    'Statement List',
    'Statement Item',
  ],
  endpoints: () => ({}),
});

export default api;
